import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import { baseApiUrl} from '@/global'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: null,
		bday:null,
		escalas:null
	},

	actions: {
		async loadEscalas({ commit }) {
			try {
				const res = await axios.get(`${baseApiUrl}/escalas`);
				commit('setEscalas', res.data); 
			} catch (e) {
				console.error('Erro ao carregar escalas:', e);
			}
		},
	},

	mutations: {
		setUser(state, user) {
			state.user = user
			if(user) {
				axios.defaults.headers.common['Authorization'] = 'bearer ' + user.token
			} else {
				delete axios.defaults.headers.common['Authorization']
			}
		},
		setBday(state, bday) {
			state.bday = bday
		},

		setEscalas(state, escalas) {
			state.escalas = escalas;
		},

	}
})